import { Checkbox, useTheme } from "@mui/material";

export type TruxSimpleCheckboxFieldProps<T> = {
  value: boolean,
  onChange: VoidFunction,
  size?: "medium" | "small",
  info?: boolean
}

export default function TruxSimpleCheckboxField<T>({ value, size, onChange, info }: TruxSimpleCheckboxFieldProps<T>) {
  const theme = useTheme();

  return <Checkbox size={size || "small"} sx={info ? {svg: {
              color: theme.palette.info.main
            }}: undefined} checked={value} onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    onChange();
  }} />
}